/**
 * Message store functions for Play Project contracts
 *
 * These are local implementations to avoid cyclic dependency with @playproject/contracts.
 * The opcodes and structures match the Tact-generated contract messages.
 */
// =============================================================================
// Message Opcodes (from Tact contracts)
// =============================================================================
export const MessageOpcodes = {
    // NftCollection messages
    PUBLIC_MINT: 16, // 0x10
    WITHDRAW: 6, // 0x06
    // NftItem messages (user reveal)
    REQUEST_REVEAL: 0x52657665, // "Reve" in ASCII
    // CollectionRegistry messages
    REGISTER_COLLECTION: 32, // 0x20
    VERIFY_COLLECTION: 33, // 0x21
    UNVERIFY_COLLECTION: 34, // 0x22
    WITHDRAW_FEES: 38, // 0x26
};
// =============================================================================
// Store Functions
// =============================================================================
export function storePublicMint(src) {
    return (builder) => {
        builder.storeUint(MessageOpcodes.PUBLIC_MINT, 32);
        builder.storeUint(src.quantity, 32);
    };
}
export function storeRequestReveal(_src) {
    return (builder) => {
        builder.storeUint(MessageOpcodes.REQUEST_REVEAL, 32);
    };
}
export function storeWithdraw(src) {
    return (builder) => {
        builder.storeUint(MessageOpcodes.WITHDRAW, 32);
        builder.storeCoins(src.amount);
        builder.storeAddress(src.to);
    };
}
export function storeRegisterCollection(src) {
    return (builder) => {
        builder.storeUint(MessageOpcodes.REGISTER_COLLECTION, 32);
        builder.storeAddress(src.collection);
        builder.storeStringRefTail(src.name);
    };
}
export function storeVerifyCollection(src) {
    return (builder) => {
        builder.storeUint(MessageOpcodes.VERIFY_COLLECTION, 32);
        builder.storeAddress(src.collection);
    };
}
export function storeUnverifyCollection(src) {
    return (builder) => {
        builder.storeUint(MessageOpcodes.UNVERIFY_COLLECTION, 32);
        builder.storeAddress(src.collection);
    };
}
export function storeWithdrawFees(src) {
    return (builder) => {
        builder.storeUint(MessageOpcodes.WITHDRAW_FEES, 32);
        builder.storeCoins(src.amount);
        builder.storeAddress(src.to);
    };
}
